import React from "react";
import Ecommerce from "../assets/Ecommerce.png";
import TodoList from "../assets/To-do.png";
import Netflix from "../assets/Netflixclone2.png";
const Projects = () => {

const projects=[
    {
        id:1,
        src:Ecommerce,
        name:Ecommerce
    },
    {
        id:2,
        src:Netflix,
        name:Netflix
    },

    {
        id:3,
        src:TodoList,
        name:TodoList
    },
]


  return (
    <div
      name="Projects"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full ">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500"> Projects</p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
        {
    projects.map(({id,src,name})=>(
<div key={id}className="shadow-md shadow-gray-600 rounded-lg">
            <img src={src} alt="" className="rounded-md  duration-200 hover:scale-105"></img>
            <div className="flex items-center justify-center">
              <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105 ">open</button>
              <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">Code</button>
            </div>
          </div>
    ))
}
          
        </div>
      </div>
    </div>
  );
};

export default Projects;
